import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiClientService } from '../../../core/http/api-client.service';
import { DeviceTypeDetailItem, DeviceTypeDto, DeviceTypeItem } from './device-types.models';

@Injectable({
  providedIn: 'root'
})
export class DeviceTypesService {
  private readonly apiClient = inject(ApiClientService);

  public getList(companyId?: string): Observable<DeviceTypeItem[]> {
    return this.apiClient.get<DeviceTypeDto[] | null>(
      '/device-types',
      companyId ? { companyId } : undefined,
    ).pipe(
      map((items) => {
        if (!Array.isArray(items)) {
          return [];
        }

        return items.map((item) => ({
          id: item.id,
          name: item.name,
        }));
      }),
    );
  }

  public getById(id: string, companyId?: string): Observable<DeviceTypeDetailItem> {
    return this.apiClient.get<DeviceTypeDto>(
      `/device-types/${encodeURIComponent(id)}`,
      companyId ? { companyId } : undefined,
    ).pipe(
      map((item) => ({
        id: item.id,
        companyId: item.companyId,
        name: item.name,
        description: item.description,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
      })),
    );
  }
}
